import {atom} from "recoil";


const userinfoAtom = atom({
  key: 'userinfoAtom',
  default: true, 
 });


 export default userinfoAtom;

